import React from "react";
import Wallet from '../../assets/images/wallet-icon.svg'
import Collection from '../../assets/images/collection-icon.svg'
import File from '../../assets/images/file-icon.svg'
import Tag from '../../assets/images/tag-icon.svg'


function CreateSell() {

    return (
        <section className="create-sell main-padding section-margin">
                <div className="container-fluid p-0">
                    <div className="heading text-center">
                        <h2>Create And Sell Your Nfts</h2>
                    </div>
                    <div className="row" >
                        <div className="col-md-6 col-xl-3 mb-3">
                            <div className="item">
                                <div className="item-content">
                                    <div className="icon">
                                        <img src={Wallet} alt="" className="img-fluid" />
                                    </div>
                                    <h3>Set up your Wallet</h3>
                                    <p>Once you’ve set up your wallet of choice, connect it to Toppy by clicking the wallet icon in the top right corner. Learn about the wallets we support.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-3 mb-3">
                            <div className="item">
                                <div className="item-content">
                                    <div className="icon">
                                        <img src={Collection} alt="" className="img-fluid" />
                                    </div>
                                    <h3>Create your collection</h3>
                                    <p>Click My Collections and set up your collection. Add social links, a description, profile & banner images, and set a secondary sales fee.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-3 mb-3">
                            <div className="item">
                                <div className="item-content">
                                    <div className="icon">
                                        <img src={File} alt="" className="img-fluid" />
                                    </div>
                                    <h3>Add your NFTs</h3>
                                    <p>Upload your work (image, video, audio, or 3D art), add a title and description, and customize your NFTs with properties, stats, and unlockable content.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-3 mb-3">
                            <div className="item">
                                <div className="item-content">
                                    <div className="icon">
                                        <img src={Tag} alt="" className="img-fluid" />
                                    </div>
                                    <h3>List them for sale</h3>
                                    <p>Choose between auctions, fixed-price listings, and declining-price listings. You choose how you want to sell your NFTs, and we help you sell them!</p>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
           
    )
}
export default CreateSell;